import { produce } from 'immer'

const initialState = {
    folder_data: {
        type: null,
        params: {},
    },
    active_folder: null,
}

export const decrementP2pFolderCount = ({ id_purchase }, folders) => {
    return {
        ...folders,
        p2p_trade: produce(folders?.p2p_trade || [], draft => {
            const purchase = draft.find(v => Number(v.id) === id_purchase)
            if (purchase) purchase.p2p_bids_count--
        }),
    }
}

const updateMainStates = (state = initialState, { type, payload }) => {
    switch (type) {
        case 'SET_FOLDER_DATA':
            return {
                ...state,
                folder_data: payload.folder_data,
                active_folder: payload.active_folder,
            }

        case 'RESET_FOLDER_DATA':
            return {
                ...state,
                folder_data: {
                    type: null,
                    params: {},
                },
                active_folder: null,
            }

        default:
            return state
    }
}

const tree = (state = initialState, action) => {
    const mainStates = updateMainStates(state, action)
    return {
        ...mainStates,
    }
}

export default tree
